(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pascal-table')) {
		customElements.define('pascal-table', class extends HTMLElement {
			connectedCallback() {
				this.scrollArea = this.querySelector('.pascal-table__scroll');
				this.table = this.querySelector('.pascal-table__data');
				this.hint = this.querySelector('.pascal-table__hint');
				if (!this.scrollArea || !this.table) return;
				this.observer?.disconnect();
				this.observer = new ResizeObserver(() => this.updateOverflow());
				this.observer.observe(this.scrollArea);
				this.observer.observe(this.table);
				this.updateOverflow();
			}

			disconnectedCallback() {
				this.observer?.disconnect();
			}

			updateOverflow() {
				const overflows = this.scrollArea.scrollWidth > this.scrollArea.clientWidth + 1;
				if (this.hint) this.hint.hidden = !overflows;
				if (overflows) this.scrollArea.setAttribute('tabindex', '0');
				else this.scrollArea.removeAttribute('tabindex');
			}
		});
	}
  } catch(e) { console.error(e); }
})();

})();
